import React from 'react';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Fieldset } from 'primereact/fieldset';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { FilterMatchMode } from 'primereact/api';
import { Link } from 'react-router-dom';
import { decode } from 'html-entities';
import { Toast } from 'primereact/toast';
import { getUrl, formatDate } from './../planner/planner';
import { Tooltip } from 'primereact/tooltip';
import { ConfirmDialog } from 'primereact/confirmdialog';

class EditSuggestionForm extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			suggestion: [],
			categories: [],
			isLoaded: false,
			locked: false,
			suggestionContent: '',
			quantity: 1,
			travellers: [],
			note: '',
			suggestion_cat_id: '',
			noteDialog: false,
			operators: [],
			operator: null,
			comments: [],
			selectedStatus: null,
			filters: {
				meta: { value: null, matchMode: FilterMatchMode.CONTAINS }
			},
			selectedStatusFilter: null,
			status: '',
			traveller: null,
			toast: React.createRef(),
			confirmDeleteDialog: false
		}

		this.getCommentAuthor = this.getCommentAuthor.bind(this);
		this.deleteSuggestion = this.deleteSuggestion.bind(this);
	}

	async deleteSuggestion() {
		await axios.delete(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`}, data: {id: this.props.id,}}).then().catch(err => console.log(err));

		window.location.href = "/suggestions";

		localStorage.setItem('suggestionDeleted', this.state.suggestion.suggestion_number)
	}

	/**
	 * Lock the scrap to the ID that is editing
	 * 
	 * @param {Object} scrapDetails The data for the current scrap
	 */
	lockSuggestion(suggestionDetails) {
		if(suggestionDetails.data.locked === false) {
			axios.put(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {
				"locked" : Math.floor(Date.now() / 1000) + ':' + this.props.currentLoggedInUser.id
			}, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} })
			.then(res => this.setState({
				isLoaded: true
			})).catch(err => console.log(err))
		}
	}

	/**
	 * Checks if the scrap is being edited by another user
	 * 
	 * @returns {Boolean} Returns true or false depending if the scrap is currently locked
	 */
	isSuggestionLocked() {
		if(this.state.locked === false || this.props.currentLoggedInUser.id === this.state.locked.ID) {
			return false;
		} else {
			return true;
		}
	}

	fieldsDisabled() {
		if(this.props.currentLoggedInUser.capabilities.edit_suggestions) {
			return false;
		} else {
			return true;
		}
	}

	/**
	 * Runs when the component mounts
	 */
	async componentDidMount() {
		const [getSuggestionDetails] = await Promise.all([
			axios.get(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }),
		]);

		this.setState({
			suggestion: getSuggestionDetails.data.suggestion,
			locked: getSuggestionDetails.data.suggestion.locked,
			suggestionContent: getSuggestionDetails.data.suggestion.suggestion,
			operators: getSuggestionDetails.data.suggestion_authors,
			operator: Number(getSuggestionDetails.data.suggestion.reported_by_user_id),
			status: getSuggestionDetails.data.suggestion.status_name,
			statuses: getSuggestionDetails.data.suggestion_statuses,
			comments: getSuggestionDetails.data.suggestion.notes,
			traveller: (getSuggestionDetails.data.suggestion.traveller_id),
			traveller_number: (getSuggestionDetails.data.suggestion.traveller_number),
			categories: getSuggestionDetails.data.suggestion_categories,
			suggestion_cat_id: getSuggestionDetails.data.suggestion.suggestion_cat_id,
			isLoaded: true,
		});

		document.title = 'Suggestion #' + getSuggestionDetails.data.suggestion.suggestion_number + ' - Planner';

		setInterval(() => {
			this.lockSuggestion(getSuggestionDetails);
		}, 15000);

		this.lockSuggestion(getSuggestionDetails);
	}

	async changeTraveller(event) {
		this.setState({
			traveller: event.value,
		});

		await axios.put(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {
			"traveller" : event.value,
		}, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }).then().catch(err => console.log(err));

		this.state.toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Traveller updated.' });

		this.updateOrderNotes();
	}

	async changeOperator(event) {
		this.setState({
			operator: event.value,
		});

		await axios.put(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {
			"reported_by_user_id" : event.value,
		}, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }).then().catch(err => console.log(err));

		this.state.toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Operator updated.' });

		this.updateOrderNotes();
	}

	/**
	 * Update the state of the order notes
	 */
	async updateOrderNotes() {
		const [getSuggestionDetails] = await Promise.all([
			axios.get(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }),
		]);

		this.setState({
			comments: getSuggestionDetails.data.suggestion.notes,
		});
	}

	async changeStatus(event) {
		this.setState({
			status: event.target.value,
		});

		await axios.put(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {
			"status" : event.target.value,
		}, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }).then().catch(err => console.log(err));

		this.state.toast.current.show({ severity: 'success', summary: 'Updated', detail: 'Status updated.' });

		this.updateOrderNotes();
	}

	/**
	 * Create a note for the suggestion
	 */
	async addNote() {
		if(this.state.note) {
			this.setState({
				noteDialog: false
			});

			const { toast } = this.state;

			await axios.put(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {
				"note" : this.state.note
			}, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }).then().catch(err => console.log(err));

			toast.current.show({ severity: 'success', summary: 'Suggestion', detail: 'Suggestion details have been updated.' });

			this.setState({
				note: ''
			});

			this.updateOrderNotes();
		} else {
			this.state.toast.current.show({ severity: 'error', summary: 'Note', detail: 'Please enter text in the note field.' });
		}
	}

	getDate(rowData) {
		return formatDate(rowData.comment_date, true);
	}

	getType(rowData) {
		let badgeClass;

		if(rowData.meta === 'System') {
			badgeClass = 'bg-dark';
		} else if (rowData.meta === 'User') {
			badgeClass = 'bg-primary';
		}

		return <span className={"badge " + badgeClass}>{rowData.meta}</span>;
	}

	rowNumber(data, props) {
		return this.state.comments.length - props.rowIndex;
	}

	/**
	 * Update the status filtering based on what the user has selected
	 * 
	 * @param {input} e Information related to the current input
	 */
	onStatusFilterChange(e) {
		const value = e.target.value;

		let _filters = { ...this.state.filters };

		_filters['meta'].value = value;

		this.setState({filters: _filters, selectedStatusFilter: value });
	}

	getSuggestionTitle() {
		if(this.props.capabilities.edit_travellers=== true || this.props.capabilities.read_travellers === true) {
			return 'Editing Suggestion: #' + this.state.suggestion.suggestion_number;
		} else {
			return 'Access Denied';
		}
	}

	resetFilter() {
		this.setState({
			selectedStatusFilter: null,
			filters: {
				meta: { value: null, matchMode: FilterMatchMode.CONTAINS }
			}
		});
	}

	optionsTemplate(e) {
		if (e) {
			return (
				<div className="flex align-items-center">
					<div>Traveller #{decode(e.traveller_number)}</div>
				</div>
			);
		}

		return '';
	}

	optionTemplate(e) {
		return (
			<div className="flex align-items-center">
				<div>Traveller #{decode(e.traveller_number)}</div>
			</div>
		);
	}

	getCommentContent(rowData) {
		return decode(rowData.comment_content);
	}

	getCommentAuthor(rowData) {
		let hasLink = false;

		if(rowData.roles && this.props.capabilities.edit_users === true) {
			hasLink = rowData.roles.includes('production_operator');
		}

		if(hasLink) {
			return <Link to={'/employee/' + Number(rowData.user_id)}>{rowData.comment_author}</Link>
		} else {
			return rowData.comment_author
		}
	}

	capitaliseFirstLetter(text) {
		return text[0].toUpperCase() + text.substring(1);
	}

	suggestionUpdate(e) {
		this.setState({reason: e.target.value});

		axios.put(getUrl() + '/wp-json/planner/v1/suggestions/' + this.props.id, {
			"suggestion" : e.target.value
		}, { headers: {"Authorization" : `Bearer ${localStorage.getItem('userToken')}`} }).then().catch(err => console.log(err));

		this.updateOrderNotes();

		this.state.toast.current.show({ severity: 'success', summary: 'Suggestion', detail: 'Suggestion Updated.' });
	}

	getCategories() {
		return '';
	}

	render() {
		const { isLoaded, toast, noteDialog, suggestion, suggestionContent,  operators, operator, travellers, traveller, status, note, comments, filters } = this.state;

		return (
			<>
				<ConfirmDialog blockScroll={true} visible={this.state.confirmDeleteDialog} onHide={() => this.setState({confirmDeleteDialog: false})} message="Are you sure you want to delete this suggestion?" header="Confirmation" icon="pi pi-exclamation-triangle" accept={this.deleteSuggestion} />
				<Toast ref={toast} position="bottom-right" />
				<div className="edit-order-bar position-sticky top-0 p-3">
					<div className="container px-0 d-flex justify-content-between align-items-center">
						<div className="d-flex">
							<div className="d-flex align-items-center">
								<Button className="bg-primary p-2 me-3 d-flex align-items-center rounded d-xxl-none" onClick={e => {this.props.onSidebarOpen(true);}}>
									<i className="pi pi-bars text-white" style={{ fontSize: '1.25rem' }}></i>
								</Button>
							</div>
							<div>
							{
								isLoaded && (
									<h1 className="mb-0 h3">{this.getSuggestionTitle()}</h1>
								)
							}
							{
								isLoaded && (
									<>
										<strong>Reported Date:</strong>&nbsp;{formatDate(suggestion.date_reported, true)}
									</>
								)
							}
							{
								!isLoaded && (
									<div>
										<i className="pi pi-spin pi-spinner" style={{ fontSize: '2.8rem' }}></i>
									</div>
								)
							}
							</div>
						</div>
						<div className="d-flex align-items-center">
						{
							this.isSuggestionLocked() && (
								<p className="d-inline mb-0 ms-3"><span className="badge bg-danger d-inline-flex align-items-center display-6"><i className="pi pi-lock me-2"></i> {this.state.locked.data.user_login} is currently editing this suggestion</span></p>
							)
						}
						{
							!this.isSuggestionLocked() && this.props.capabilities.delete_suggestions && isLoaded && (
								<Button type="button" label="Delete" icon="pi pi-trash" onClick={(e) => this.setState({confirmDeleteDialog: true})} className="ms-3 bg-danger" />
							)
						}
						</div>
					</div>
				</div>
				{
					isLoaded && (this.props.capabilities.edit_travellers || this.props.capabilities.read_travellers) && ( // https://stackoverflow.com/questions/70682832/
					<>
						<Dialog blockScroll={true} header="Add Note" visible={noteDialog} style={{ width: '50vw' }} onHide={(e) => this.setState({noteDialog: false})}>
							<InputTextarea value={note} onChange={(e) => this.setState({note: e.target.value})} rows={5} maxLength={500} />
							<span>{(500 - note.length)+ " characters left"}</span><br />
							<Button type="button" label="Save" icon="pi pi-save" onClick={this.addNote.bind(this)} className="mt-4" />
						</Dialog>
						<form className="container px-4 px-xxl-0 mt-5">
							<div className="row">
								<div className="col-12">
									<Fieldset legend="Suggestion Information">
										<div className="container">
											<div className="row">
												<div className="col-12 col-lg-4">
													<strong className="w-100 mb-1 d-block">Reported By:</strong>
													{
														this.props.capabilities.read_travellers && !this.props.capabilities.edit_travellers && (
															<Dropdown filterInputAutoFocus={false} disabled={true} placeholder="Reported By" value={operator} options={operators} optionLabel="display_name" optionValue="id" className="w-full md:w-14rem" onChange={this.changeOperator.bind(this)} />
														)
													}
													{
														this.props.capabilities.edit_travellers && (
															<Dropdown filterInputAutoFocus={false} disabled={this.isSuggestionLocked()} placeholder="Reported By" value={operator} options={operators} optionLabel="display_name" optionValue="id" className="w-full md:w-14rem" onChange={this.changeOperator.bind(this)} />
														)
													}
												</div>
												<div className="col-12 col-lg-4">
													<strong className="w-100 mb-1 d-block">Status:</strong>
													{
														this.props.capabilities.read_travellers && !this.props.capabilities.edit_travellers && (
															<Dropdown filterInputAutoFocus={false} disabled={true} placeholder="Select a Status" value={status} options={[{name: 'Approved', slug: 'planner-approved'},{name: 'Dismissed', slug: 'planner-dismissed'},{name: 'Reported', slug: 'planner-reported'}]} optionValue="slug" optionLabel="name" className="w-full md:w-14rem" onChange={this.changeStatus.bind(this)} />
														)
													}
													{
														this.props.capabilities.edit_travellers && (
															<Dropdown filterInputAutoFocus={false} disabled={this.isSuggestionLocked()} placeholder="Select a Status" value={status} options={[{name: 'Approved', slug: 'planner-approved'},{name: 'Dismissed', slug: 'planner-dismissed'},{name: 'Reported', slug: 'planner-reported'}]} optionValue="slug" optionLabel="name" className="w-full md:w-14rem" onChange={this.changeStatus.bind(this)} />
														)
													}
												</div>
												<div className="col-12 col-lg-4">
													<strong className="w-100 mb-1 d-block">Category:</strong>
													{
														this.props.capabilities.read_travellers && !this.props.capabilities.edit_travellers && (
															<Dropdown filterInputAutoFocus={false} disabled={true} placeholder="Select a Category" value={this.state.suggestion_cat_id} options={this.state.categories} optionValue="id" optionLabel="name" className="w-full md:w-14rem" onChange={this.changeStatus.bind(this)} />
														)
													}
													{
														this.props.capabilities.edit_travellers && (
															<Dropdown filterInputAutoFocus={false} disabled={this.isSuggestionLocked()} placeholder="Select a Category" value={this.state.suggestion_cat_id} options={this.state.categories} optionValue="id" optionLabel="name" className="w-full md:w-14rem" onChange={this.changeStatus.bind(this)} />
														)
													}
												</div>
											</div>
											<div className="col-12 mt-3">
												<strong className="w-100 mb-1 d-block">Suggestion:</strong>
												<InputTextarea value={suggestionContent} disabled={this.fieldsDisabled()} onChange={(e) => this.setState({suggestionContent: e.target.value})} rows={5} maxLength={500} onBlur={(e) => this.suggestionUpdate(e)} />
											</div>
										</div>
									</Fieldset>
								</div>
							</div>
							<div className="row mt-5 mb-5">
								<div className="col-12">
									<Fieldset legend="Traveller">
										<div className="container">
											<div className="row">
												<div className="col-12 col-lg-4">
													<div>
														<strong className="w-100 mb-1 d-block">Traveller:</strong>
													</div>
													<Link to={"/traveller/" + this.state.traveller}>#{this.state.traveller_number}</Link>
												</div>
												<div className="col-12 col-lg-4">
													<div>
														<strong className="w-100 mb-1 d-block">Order:</strong>
													</div>
													{
														this.props.capabilities.read_shop_orders && (
															<Link to={"/job/" + this.state.suggestion.order_id}>#{this.state.suggestion.order_number}</Link>
														)
													}
													{
														!this.props.capabilities.read_shop_orders && (
															<>#{this.state.suggestion.order_number}</>
														)
													}
												</div>
												<div className="col-12 col-lg-4">
													<div>
														<strong className="w-100 mb-1 d-block">Product:</strong>
													</div>
													<Tooltip autoHide={false} target=".product-title" />
													{
														this.props.capabilities.read_products && (
															<><Link data-pr-tooltip={this.state.suggestion.product_description} data-pr-position="left" className="product-title" to={"/product/" + this.state.suggestion.product_id}>{this.state.suggestion.product_sku}</Link> <div className="badge bg-primary text-white">x {this.state.suggestion.product_qty}</div></>
														)
													}
													{
														!this.props.capabilities.read_products && (
															<><span data-pr-tooltip={this.state.suggestion.product_description} data-pr-position="left" className="product-title">{this.state.suggestion.product_sku}</span> <div className="badge bg-primary text-white">x {this.state.suggestion.product_qty}</div></>
														)
													}
												</div>
											</div>
										</div>
									</Fieldset>
								</div>
							</div>
							<div className="row mt-5 mb-5">
								<div className="col-12">
									<Fieldset legend="Notes">
										<div className="container">
											<div className="row">
												{
													isLoaded && this.props.capabilities.edit_suggestions && (
														<div className="col-12">
															<div style={{float: 'right', marginTop: '-2rem'}} className="mb-3">
																<Button type="button" label="Add Note" icon="pi pi-comments" onClick={(e) => this.setState({noteDialog: true})} className="ms-3" />
															</div>
														</div>
													)
												}
												<DataTable dataKey="content.comment_ID" value={comments} tableStyle={{ minWidth: '50rem' }} filters={filters} paginator rows={10}>
													<Column header="Note #" key="content.comment_ID" field="content.comment_ID" body={this.rowNumber.bind(this)} />
													<Column key="comment_date" field="content.comment_date" header="Date" body={this.getDate} style={{ minWidth: '12rem' }} />
													<Column key="comment_author" field="comment_author" header="Author" body={this.getCommentAuthor} />
													<Column key="comment_content" field="comment_content" header="Note" body={this.getCommentContent} />
												</DataTable>
											</div>
										</div>
									</Fieldset>
								</div>
							</div>
						</form>
					</>
				)
			}
			</>
    );
  }
}
export default EditSuggestionForm;